var _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatPopularCharacters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#fff0fa",
    stroke: "#f0a8e0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 14 L44.5 28 L59.5 28 L47.5 37 L52 51 L40 42 L28 51 L32.5 37 L20.5 28 L35.5 28Z",
    fill: "#f9d64f",
    stroke: "#c8a800",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20 L42.5 28 L50.5 28 L44.5 33 L47 41 L40 36 L33 41 L35.5 33 L29.5 28 L37.5 28Z",
    fill: "#fce990",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 20,
    r: 3,
    fill: "#f9d64f",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 20,
    r: 3,
    fill: "#f9d64f",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 50,
    r: 2,
    fill: "#f0a8e0",
    opacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 50,
    r: 2,
    fill: "#f0a8e0",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 58 Q22 55 25 55 Q28 55 28 58 Q28 61 22 64 Q16 61 16 58 Q16 55 19 55 Q22 55 22 58Z",
    fill: "#e84080",
    opacity: 0.8,
    transform: "scale(0.6) translate(17 28)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58 Q58 55 61 55 Q64 55 64 58 Q64 61 58 64 Q52 61 52 58 Q52 55 55 55 Q58 55 58 58Z",
    fill: "#e84080",
    opacity: 0.8,
    transform: "scale(0.6) translate(38 28)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatPopularCharacters);
export default __webpack_public_path__ + "static/media/cat-popular-characters.817de1a53aa6de4bb54fa992aae68d63.svg";
export { ForwardRef as ReactComponent };